import { INotification } from '@/bundles/Notification/interfaces/INotification';
import { Notification } from '@/bundles/Notification/models/Notification';

export default class NotificationMapper {
  mapToModel (data: INotification) {
    return new Notification(data);
  }
}
